import { UnauthorizedError } from '@omecare/utils';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import http from '@/utils/http.service';
import {
  GetWorkScheduleSlotItemResponse,
  getWorkScheduleSlotItemSchema,
} from './use-get-office-work-schedules-slots';

export type GetWorkScheduleSlotByIdResponse = GetWorkScheduleSlotItemResponse;

export const getOfficeWorkScheduleSlotById = (id: string) => async () => {
  return http.workScheduleSlots
    .getById(id)
    .then<GetWorkScheduleSlotByIdResponse>(({ response, transform }) => {
      const result = transform.handle({
        response,
        attributes: {
          startAt: true,
          endAt: true,
          rrule: true,
          exdate: true,
          sourceId: true,
          occurenceIndex: true,
          slotType: true,
          withAssistante: true,
          forceWithoutAssistant: true,
          dayOfWeek: true,
          periodOfTheDay: true,
          createdAt: true,
          updatedAt: true,
        },
        relations: {
          doctorAttending: true,
          sequence: true,
        },
        schema: getWorkScheduleSlotItemSchema,
      });

      return result as GetWorkScheduleSlotByIdResponse;
    });
};

export const useGetOfficeWorkScheduleSlotByIdQuery = (
  id: string,
  enabled: boolean,
): UseQueryResult<GetWorkScheduleSlotByIdResponse, UnauthorizedError> => {
  return useQuery({
    queryFn: getOfficeWorkScheduleSlotById(id),
    queryKey: ['office-work-schedule-slot-by-id'],
    retry: false,
    enabled,
  });
};
